<template>
  <div :id="id" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators" v-if="gallery && gallery.length > 0">
      <button
        type="button"
        :data-bs-target="'#' + id"
        data-bs-slide-to="0"
        class="active"
        aria-current="true"
        aria-label="Slide 1">
      </button>
      <button
        v-for="(img, index) in gallery"
        :key="index"
        type="button"
        :data-bs-target="'#' + id"
        :data-bs-slide-to="index + 1"
        :aria-label="'Slide ' + (index + 2)">
      </button>
    </div>

    <div class="carousel-inner">
      <div class="carousel-item active">
        <img
          class="d-block w-100 product-image"
          :src="mainImage"
          :alt="mainImageAlt">
      </div>
      <div
        v-for="(img, index) in gallery"
        :key="index"
        class="carousel-item">
        <img
          v-lazy="mediaUrl + img.img"
          class="d-block w-100"
          :alt="mainImageAlt">
      </div>
    </div>
    <template v-if="gallery && gallery.length > 0">
      <button
        aria-label="قبلی"
        class="carousel-control-prev"
        type="button"
        :data-bs-target="'#' + id"
        data-bs-slide="next">
        <i class="fa fa-arrow-left color-black" aria-hidden="true"></i>
      </button>
      <button
        aria-label="بعدی"
        class="carousel-control-next"
        type="button"
        :data-bs-target="'#' + id"
        data-bs-slide="prev">
        <i class="fa fa-arrow-right color-black" aria-hidden="true"></i>
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProductImageCarousel',
  props: {
    id: {
      type: String,
      required: true
    },
    mainImage: {
      type: String,
      required: true
    },
    mainImageAlt: {
      type: String,
      required: true
    },
    gallery: {
      type: Array,
      default: () => []
    },
    mediaUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
#carouselProduct {
  width: -webkit-fill-available;
  margin: 0px;
}

.carousel-indicators [data-bs-target] {
  background-color: #575757;
}

.product-image {
  aspect-ratio: 1/1;
}

.carousel-control-prev,
.carousel-control-next {
  width: 10%;
}

.carousel-control-prev i,
.carousel-control-next i {
  font-size: 25px;
}

@media (max-width: 768px) {
  #carouselProduct {
    margin: 0 !important;
  }
}

.carousel-item {
    background: #ebebeb;
    border-radius: 24px;
}
</style>
